import { setAuthToken } from '../../api/utilities/utilities';
import { handleActions } from 'redux-actions'

/* ---------- ACTIONS  ---------- */
export const SAVE_TOKEN = "SAVE_TOKEN";
export const REFRESHING_TOKEN = "REFRESHING_TOKEN";
export const DONE_REFRESHING_TOKEN = "DONE_REFRESHING_TOKEN";
export const SETUP_AUTH_FAIL = "SETUP_AUTH_FAIL";

/* ---------- ACTION CREATORS ---------- */

export function saveToken(token) {
  setAuthToken(token)
  return {
    type: SAVE_TOKEN,
    token: token
  }
}

export function startRefreshingToken(token) {
  return {
    type: REFRESHING_TOKEN, 
    refreshToken: token, 
  }
}

export function doneRefreshingToken() {
  return { 
    type: DONE_REFRESHING_TOKEN
  }
}

export function setAuthFail(authFailFn) {
  return {
    type: SETUP_AUTH_FAIL, 
    authFailFn: authFailFn
  }
}

/* ---------- REDUCER ---------- */
const initialState = {
  authFailFn: null,
  token: null,
  freshTokenPromise: null
};

const handlers = {
  [SAVE_TOKEN]: (state, action) => {
    return {
      ...state,
      token: action.token
    }
  },
  [REFRESHING_TOKEN]: (state, action) => {
    return {
      ...state,
      freshTokenPromise: action.freshTokenPromise
    }
  },
  [DONE_REFRESHING_TOKEN] : (state) => {
    return {
      ...state, 
      freshTokenPromise: null
    }
  }, 
  [SETUP_AUTH_FAIL] : (state, action) => {
    return {
      ...state, 
      authFailFn: action.authFailFn
    }
  }
}

export default handleActions(handlers, initialState);



// WEBPACK FOOTER //
// ./src/redux-modules/modules/auth.js